import React, { Component } from "react";

import TextEditor from "../../TextEditor/TextEditor";

import "./styles.css";

class QuestionCreatorBottomMenu extends Component {
  handlePrototype() {
    if (this.props.onActivity)
      window.open(`/question/prototype/${this.props.questionId}`);
    else
      this.props.history.push(`/question/prototype/${this.props.questionId}`);
  }

  render() {
    return (
      <>
        {this.props.showQuestionFeedback && (
          <TextEditor
            editorType={{ name: "feedback", id: 2 }}
            changeQuestionFeedback={this.props.changeQuestionFeedback}
            textContent={this.props.feedbackContent}
            questionId={this.props.questionId}
            readOnly={this.props.readOnly}
          />
        )}
        {this.props.moreInfo && (
          <div className="question-creator-more-info">
            <div className="m-2">
              <span className="mr-2">Dificuldade:</span>
              <select
                id="ano"
                onChange={e =>
                  this.props.difficultyChanger(Number(e.target.value))
                }
                disabled={this.props.readOnly}
              >
                <option value="1">Nível 1</option>
                <option value="2">Nível 2</option>
                <option value="3">Nível 3</option>
              </select>
            </div>
            <div className="m-2">
              <span className="mr-2">Grau:</span>
              <select
                onChange={e => this.props.gradeChanger(Number(e.target.value))}
                disabled={this.props.readOnly}
              >
                {this.props.grades.map(grade => (
                  <option value={grade.grade} key={grade.grade}>
                    {grade.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="m-2">
              <span className="mr-2">Autor:</span>
              <input
                className="pl-2 pr-2"
                defaultValue={this.props.author}
                onChange={e => this.props.authorChanger(e.target.value)}
                disabled={this.props.readOnly}
              />
            </div>
            <div className="m-2">
              <span className="mr-2">Ano:</span>
              <input
                className="pl-2 pr-2"
                defaultValue={this.props.questionYear}
                onChange={e => this.props.yearChanger(e.target.value)}
                disabled={this.props.readOnly}
              />
            </div>
            <div className="m-2">
              <span className="mr-2">Habilidade:</span>
              <select
                id="habilidade"
                value={this.props.ability}
                onChange={e =>
                  this.props.abilityChanger(Number(e.target.value))
                }
                disabled={this.props.readOnly}
              >
                {this.props.abilities.map(ability => (
                  <option value={ability.id} key={ability.id}>
                    {ability.code}
                  </option>
                ))}
              </select>
            </div>
            <div className="m-2">
              <span className="mr-2">Privada:</span>
              <input
                type="checkbox"
                className="pl-2 pr-2"
                defaultChecked={this.props.private}
                onChange={e => this.props.privateChanger(e.target.checked)}
                disabled={this.props.readOnly}
              />
            </div>
          </div>
        )}
        <div className="question-creator-bottom-menu">
          {!this.props.readOnly ? (
            <button
              className="question-creator-bottom-menu-add-menu"
              onClick={() => this.props.toggleQuestionFeedback()}
            >
              {!this.props.showQuestionFeedback
                ? "Adicionar Feedback"
                : "Remover Feedback"}
            </button>
          ) : (
            <div></div>
          )}
          {!this.props.readOnly && (
            <div className="question-creator-bottom-menu-right-section">
              <button
                className="question-creator-bottom-menu-more-info-menu"
                onClick={this.props.showMoreInfo}
              >
                Mais configurações
              </button>
              <div>
                <button onClick={() => this.handlePrototype()}>
                  <i className="fa fa-eye fa-lg"></i>
                </button>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default QuestionCreatorBottomMenu;
